/**
 * RegistrationTile - the header tile «Eintragung bei Versicherern» (Stefan P5 V2.0 Kap. 10.5): «x von n
 * eingetragen» and the chips (gemeldet, erinnert, Klärung, automatisch übertragen, ...), next to the
 * Mandatskacheln and the Portalstatus. The text is the api's (registrationTileLabel); a click opens the
 * area «Mandate & Eintragungen».
 */

import type { RegistrationTilesDto } from '@brokly/shared';

export function RegistrationTile({ tiles, onOpen }: { tiles: RegistrationTilesDto; onOpen: () => void }) {
  const attention = tiles.klaerung + tiles.abgelehnt + tiles.zur_freigabe + tiles.zurueckgestellt + tiles.rueckfrage > 0;
  const done = tiles.total > 0 && tiles.eingetragen === tiles.total;
  const tone = attention
    ? 'bg-orange-100 text-orange-900 dark:bg-orange-950/40 dark:text-orange-200'
    : done
      ? 'bg-emerald-100 text-emerald-900 dark:bg-emerald-950/40 dark:text-emerald-200'
      : 'bg-muted text-muted-foreground';
  return (
    <button
      type="button"
      data-testid="registration-tile"
      title="Eintragung bei Versicherern"
      aria-label={`Eintragung bei Versicherern: ${tiles.label}`}
      onClick={onOpen}
      className={`cursor-pointer rounded-md px-2 py-1 text-xs font-medium hover:brightness-95 ${tone}`}
    >
      {tiles.label}
    </button>
  );
}
